// @flow

import remote from './remote';

export type RequestPhoneVerificationPayload = {
  type: 'sms' | 'api'
};

export function acceptTerms() {
  return remote.post('terms/accept?embed=payments,limit');
}

export function claimCredit() {
  return remote.post('bonuses/daily');
}

export function createUser(data) {
  return remote.post('users', data);
}

export function getUserDetails() {
  return remote.get('users/current', {
    embed: ['payments', 'limit']
  });
}

export function createPlayUpAccount(data) {
  return remote.post('users/campaigns/claim_playup_account', data);
}

export function playUpDepositCampaign(data) {
  return remote.post('users/campaigns/claim_playup_doubleup', data);
}

export function getPlayUpCampaignStatus() {
  return remote.post('users/campaigns/claim_playup_account');
}

export function getUserQuestions() {
  return remote.get('users/questions');
}

export function inviteOthers(data) {
  return remote.post('share', data);
}

export function resetPassword(email) {
  return remote.post('password/email', { email });
}

export function updateCurrentUser(data) {
  return remote.post('users/current', data);
}

export function requestPhoneVerification(data: RequestPhoneVerificationPayload) {
  return remote.post('verification/phone', data);
}

export function requestEmailVerification() {
  return remote.post('verification/email');
}

export function verifyPhone(code) {
  return remote.post(`verification/phone/${code}`);
}
